@if (!itemDetail.isLoading() && !itemDetail.hasValue()) {
  <div class="back-and-name-banner flex gap-4" data-cy="back-and-name-banner">
    @if (!closeOnly()) {
      <button class="!min-w-12 back-button" cue-button size="small" (click)="closeDetail()" data-cy="back-button">
        <cue-icon [icon]="ICONS.cueArrowFullLeft" />
      </button>
    }

    <h2 class="m-0" data-cy="resource-name-h2">
      {{ translation.navigation.mapItemDetailNotFoundHeader | transloco }}
    </h2>
  </div>
  <div>
    {{ translation.navigation.mapItemDetailNotFoundText | transloco }}
  </div>
} @else {
  @if (itemDetail.isLoading()) {
    <cue-loading />
  }
  @if (!itemDetail.isLoading() && itemDetail.hasValue()) {
    <div class="breadcrumb-container breadcrumb-mobile" data-cy="breadcrumb-banner">
      @for (breadcrumb of itemDetail.value().breadcrumbWithIds; track breadcrumb; let i = $index) {
        <span
          class="breadcrumb"
          [class.active-breadcrumb]="isActiveBreadcrumb(breadcrumb.item1, activatedRoute.queryParams | async)"
        >
          @if (i !== 0) {
            <cue-icon [icon]="ICONS.cueArrowRight" />
          }
          @if (itemDetail.value().displayNameForApp | localizedString) {
            <span
              (click)="
                moveToArea(
                  breadcrumb.item1,
                  itemDetail.value().displayNameForApp,
                  itemDetail.value().resourceId,
                  itemDetail.value().qrCodeId
                )
              "
              class="part"
              >{{ breadcrumb.item2 | localizedString }}</span
            >
          } @else if (itemDetail.value().name | localizedString) {
            <span
              (click)="
                moveToArea(
                  breadcrumb.item1,
                  itemDetail.value().name,
                  itemDetail.value().resourceId,
                  itemDetail.value().qrCodeId
                )
              "
              class="part"
              >{{ breadcrumb.item2 | localizedString }}</span
            >
          }
        </span>
        <!--                <span-->
        <!--                    class="breadcrumb"-->
        <!--                    [class.active-breadcrumb]="isActiveBreadcrumb(breadcrumb.item1, activatedRoute.queryParams | async)"-->
        <!--                >-->
        <!--                    @if (i !== 0) {-->
        <!--                        <cue-icon [icon]="ICONS.cueArrowRight" />-->
        <!--                    }-->
        <!--                    <span (click)="moveToArea(breadcrumb.item1)" class="part">{{ breadcrumb.item2 | localizedString }}</span>-->
        <!--                </span>-->
      }
    </div>
    <div class="back-and-name-banner flex gap-4" data-cy="back-and-name-banner">
      @if (!closeOnly()) {
        <button class="!min-w-12 back-button" cue-button size="small" (click)="closeDetail()" data-cy="back-button">
          <cue-icon [icon]="ICONS.cueArrowFullLeft" />
        </button>
      } @else {
        <button class="!min-w-12 back-button" cue-button size="small" (click)="closePanel.emit()" data-cy="back-button">
          <cue-icon [icon]="ICONS.cueArrowFullLeft" />
        </button>
      }
      @if (itemDetail.value().unitInformation) {
        <button
          class="!min-w-12 back-button"
          cue-button
          size="small"
          (click)="itemDetail.reload()"
          data-cy="refresh-button"
        >
          <cue-icon [icon]="ICONS.cueRefresh" />
        </button>
      }
      <h2 class="m-0" data-cy="resource-name-h2">
        {{ mapItemName(itemDetail.value()) }}
      </h2>
      @if (showRouteIsVisible()) {
        <button
          class="button-kiosk-portrait"
          cue-button
          size="small"
          [link]="!startSelectionPriority()"
          (click)="setItemAsTarget(itemDetail.value())"
          data-cy="as-target-button"
        >
          <cue-icon [icon]="ICONS.cueTarget" />
          {{ translation.navigation.showRoute | transloco }}
        </button>
      }
    </div>

    <div class="detail-wrapper" cueHasScrollbar data-cy="navigation-item-detail">
      <div class="room-info mt-2" data-cy="info-block">
        @if (scheduleDetail.value()) {
          <div
            class="schedule-status mt-2"
            [class.with-heading]="scheduleDetail.value().subject || scheduleDetail.value().organizer"
          >
            <span class="status-tag" [ngStyle]="getAvailaibilityColor(scheduleDetail.value())">
              {{ getAvailaibilityText(scheduleDetail.value()) | transloco }}
            </span>

            @if (scheduleDetail.value().subject || scheduleDetail.value().organizer) {
              <div class="schedule-heading">
                <span class="subject" data-cy="assist-navigation-resource-event-subject">
                  {{ scheduleDetail.value().subject }}
                </span>
                @if (scheduleDetail.value().realStart && scheduleDetail.value().realEnd) {
                  <div class="organizer">
                    <span class="label">{{ scheduleDetail.value().realStart | date: 'dd.MM. HH:mm' }} - </span>
                    <span class="value">{{ scheduleDetail.value().realEnd | date: 'dd.MM. HH:mm' }}</span>
                  </div>
                }

                @if (scheduleDetail.value().organizer) {
                  <div class="organizer">
                    <span class="label">{{ translation.reservationPopup.organizer | transloco }} :</span>
                    <span class="value">{{ scheduleDetail.value().organizer }}</span>
                  </div>
                }
              </div>
            }
          </div>
        }
        @if (isResource() && itemDetail.value() && itemDetail.value().workingHours?.workingHoursSetting) {
          <div class="working-hours">
            <cue-working-hours
              expensionPanelClass="show-panel show-panel--small"
              [workingHourInfo]="itemDetail.value()"
            />
          </div>
        }

        @if (itemDetail.value()) {
          <table>
            @if (itemDetail.value().showCodeInDetail) {
              <tr>
                <th>
                  <div>
                    {{ translation.resourceDetail.qrCode | transloco }}
                  </div>
                </th>
                <td>
                  {{ itemDetail.value().qrCode }}
                </td>
              </tr>
            }
            @if (
              (itemDetail.value().name | localizedString) || (itemDetail.value().displayNameForApp | localizedString)
            ) {
              <tr class="displayName">
                <th>
                  <div>
                    {{ translation.resourceDetail.name | transloco }}
                  </div>
                </th>
                <td>
                  {{ mapItemName(itemDetail.value()) }}
                </td>
              </tr>
            }
            @if (itemDetail.value().qrCategoryName) {
              <tr>
                <th>
                  <div>
                    {{ translation.resourceDetail.qrCategoryName | transloco }}
                  </div>
                </th>
                <td class="text-w-icon">
                  @if (!!itemDetail.value().qrCategoryIcon) {
                    <img
                      [src]="itemDetail.value().qrCategoryIcon"
                      [class.img-cover]="itemDetail.value().imagePreferCover"
                      [ngStyle]="{
                        'object-position': itemDetail.value().imageObjectPosition,
                      }"
                      class="h-5 w-5 max-w-none categoryIcon"
                    />
                  }
                  {{ itemDetail.value().qrCategoryName | localizedString }}
                </td>
              </tr>
            }

            @if (!isResource() && (itemDetail.value().resourceTypeName | localizedString)) {
              <tr>
                <th class="text-w-icon">
                  @if (!!itemDetail.value().resourceTypeIcon) {
                    <img
                      [src]="itemDetail.value().resourceTypeIcon"
                      [ngStyle]="{
                        'object-position': itemDetail.value().imageObjectPosition,
                      }"
                      [class.img-cover]="itemDetail.value().imagePreferCover"
                      class="h-5 w-5 max-w-none categoryIcon"
                    />
                  }
                  {{ itemDetail.value().resourceTypeName | localizedString }}
                </th>
                @if (itemDetail.value().resourceId) {
                  <td class="qrCode" (click)="openParentResource(itemDetail.value().resourceId)">
                    {{
                      (itemDetail.value().displayNameForApp | localizedString) ??
                        (itemDetail.value().name | localizedString)
                    }}
                  </td>
                } @else {
                  <td>
                    {{
                      (itemDetail.value().displayNameForApp | localizedString) ??
                        (itemDetail.value().name | localizedString)
                    }}
                  </td>
                }
              </tr>
            }
            @if (isResource() && (itemDetail.value().resourceTypeName | localizedString)) {
              <tr>
                <th>
                  {{ translation.resourceDetail.type | transloco }}
                </th>
                <td class="text-w-icon">
                  @if (itemDetail.value().resourceTypeIcon) {
                    <img
                      [src]="itemDetail.value().resourceTypeIcon"
                      [class.img-cover]="itemDetail.value().imagePreferCover"
                      [ngStyle]="{
                        'object-position': itemDetail.value().imageObjectPosition,
                      }"
                      class="h-5 w-5 max-w-none categoryIcon"
                    />
                  }
                  {{ itemDetail.value().resourceTypeName | localizedString }}
                </td>
              </tr>
            }
            @if (itemDetail.value().isCapacityUnlimited || itemDetail.value().capacity != null) {
              @if (itemDetail.value().isCapacityUnlimited) {
                <tr>
                  <th>
                    <div>
                      {{ translation.resourceDetail.capacity | transloco }}
                    </div>
                  </th>
                  <td>
                    {{ translation.common.unlimited | transloco }}
                  </td>
                </tr>
              } @else if (isResource()) {
                <tr>
                  <th>
                    <div>
                      {{ translation.resourceDetail.capacity | transloco }}
                    </div>
                  </th>
                  <td>
                    {{ itemDetail.value().capacity }}
                  </td>
                </tr>
              }
            }
          </table>

          @if (itemDetail.value().qrCodes | poisCanBeShownInResource; as poisForResourceDetailList) {
            <cue-pois
              [pois]="poisForResourceDetailList"
              [selectedQrCodeId]="resourcePoiIdentification().qrCodeId"
              (poiClicked)="openPoiDetail($event.qrCodeId)"
            />
          }
        }
        @if (itemDetail.value() && itemDetail.value().objects?.length > 0) {
          <cue-controllable-objects
            [objectList]="itemDetail.value().objects"
            [qrCodeId]="itemDetail.value().qrCodeId"
            [qrCodeListOfResource]="itemDetail.value().qrCodes | qrIdList"
          />
        }
        @if (itemDetail.value().resourceDescription) {
          <div class="description">
            <div
              class="break-words custom-quill-styles"
              [innerHTML]="itemDetail.value().resourceDescription | localizedString | cueCustomUnsafeSanitize"
            ></div>
          </div>
        }
        @if (itemDetail.value().unitInformation) {
          <hr />
          <cue-unit-detail [unitInfo]="itemDetail.value().unitInformation" />
        }

        @for (simpleFilter of getSimpleFiltersByResourceTypeId($any(itemDetail.value())); track simpleFilter) {
          @if (simpleFilter.visible && simpleFilter.value.value) {
            <table>
              <tr>
                @if (simpleFilter.value.imageUrl) {
                  <th>
                    <div class="flex">
                      <img
                        [class.img-cover]="itemDetail.value().imagePreferCover"
                        [ngStyle]="{
                          'object-position': itemDetail.value().imageObjectPosition,
                        }"
                        [src]="simpleFilter.value.imageUrl | imageWidth: 30"
                        class="mr-3"
                      />
                      {{ simpleFilter.name | localizedString }}
                    </div>
                  </th>
                  <td>
                    @if (simpleFilter.value.value === true) {
                      <cue-icon [icon]="ICONS.cueCheck" class="correct" />
                    }

                    @if (simpleFilter.value.value === false) {
                      <cue-icon [icon]="ICONS.cueClose" class="incorrect" />
                    }

                    @if (simpleFilter.value.value !== true && simpleFilter.value.value !== false) {
                      <div [innerHTML]="simpleFilter.value.value | localizedString | cueCustomUnsafeSanitize"></div>
                    }
                  </td>
                } @else {
                  <th>
                    <div>
                      {{ simpleFilter.name | localizedString }}
                    </div>
                  </th>
                  <td>
                    @if (simpleFilter.value.value === true) {
                      <cue-icon [icon]="ICONS.cueCheck" class="correct" />
                    }

                    @if (simpleFilter.value.value === false) {
                      <cue-icon [icon]="ICONS.cueClose" class="incorrect" />
                    }

                    @if (simpleFilter.value.value !== true && simpleFilter.value.value !== false) {
                      <div
                        [innerHTML]="simpleFilter.value.value | localizedString | cueCustomUnsafeSanitize"
                        class="custom-html"
                      ></div>
                    }
                  </td>
                }
              </tr>
            </table>
          }
        }

        @if (itemDetail.value()) {
          <div class="content-centerer-inner">
            @for (
              enumerableFilter of getEnumerableFiltersByResourceTypeId($any(itemDetail.value()));
              track enumerableFilter
            ) {
              @if (enumerableFilter.visible) {
                <ul class="room-properties">
                  <div class="item-label">
                    {{ enumerableFilter.name | localizedString }}
                  </div>
                  @for (value of enumerableFilter.value; track value) {
                    <li>
                      <div class="img-wrapper">
                        <img
                          [ngStyle]="{
                            'object-position': itemDetail.value().imageObjectPosition,
                          }"
                          [class.img-cover]="itemDetail.value().imagePreferCover"
                          [src]="value.imageUrl | imageWidth: 30"
                        />
                      </div>
                      <span class="descriptionText">
                        {{ value.title | localizedString }}
                      </span>
                    </li>
                  }
                </ul>
              }
            }
          </div>
        }
      </div>

      @if (itemDetail.value().audioUrl | localizedString) {
        <audio controls [src]="itemDetail.value().audioUrl | localizedString" data-cy="navigation-detail-audio"></audio>
      }

      @if (itemDetail.value().files?.length > 0) {
        <hr />
      }
      <cue-file-gallery [files]="itemDetail.value().files" data-cy="navigation-detail-files" />
    </div>

    @if (!closeOnly()) {
      <div class="buttons-wrapper" [class.show]="isReservableResource() && (kioskId() !== null || appId() !== null)">
        @if (!itemDetail.value().notNavigationPoint && (!isResource() || itemDetail.value().qrCodes?.length > 0)) {
          @if (kioskId() === null && appId() === null && itemDetail.value().setAsStart) {
            <button
              cue-button
              [link]="!startSelectionPriority()"
              size="small"
              (click)="setItemAsStart(itemDetail.value())"
              class="xs-font-small"
              data-cy="set-as-start-button"
            >
              <cue-icon [icon]="ICONS.cueStart" />
              {{ translation.navigation.selectAsStart | transloco }}
            </button>
          }
          @if (kioskId() === null && appId() === null && itemDetail.value().setAsTarget) {
            <button
              cue-button
              size="small"
              [link]="startSelectionPriority()"
              (click)="setItemAsTarget(itemDetail.value())"
              class="xs-font-small"
              data-cy="set-as-start-target"
            >
              <cue-icon [icon]="ICONS.cueTarget" />
              {{ translation.navigation.navigateTo | transloco }}
            </button>
          }
          @if (showRouteIsVisible()) {
            <button
              class="button-kiosk-landscape"
              cue-button
              size="small"
              [link]="startSelectionPriority() === false"
              (click)="setItemAsTarget(itemDetail.value())"
              data-cy="set-as-target-button"
            >
              <cue-icon [icon]="ICONS.cueTarget" />
              {{ translation.navigation.showRoute | transloco }}
            </button>
          }

          @if (kioskId() === null && appId() === null) {
            <button
              class="!min-w-12 button-share-detail xs-font-small link"
              cue-button
              size="small"
              (click)="shareDetail()"
              data-cy="share-button"
            >
              <cue-icon [icon]="ICONS.cueShare"></cue-icon
              ><span class="button-text">{{ translation.navigation.share | transloco }}</span>
            </button>
          }
        }

        @if (isReservableResource() && (kioskId() !== null || appId() !== null)) {
          <a
            cue-button
            [href]="reservationUrl()"
            target="_blank"
            rel="noopener noreferrer"
            data-cy="set-as-target-button"
            size="small"
          >
            <cue-icon [icon]="ICONS.cueCalendar" />
            {{ translation.navigation.reserveMe | transloco }}
          </a>
        }
      </div>
    }
  }
}
